import { DocumentNode, gql } from '@apollo/client'

export const GET_ACCOUNT: DocumentNode = gql`
    query GetAccount {
        getAccount {
            ... on GlobalUser {
                userId
                email
                role
                language
            }
            ... on Parent {
                userId
                email
                role
                firstname
                lastname
                phone
                phoneSecond
                address
                city
                zip
                country
                addressSecond
                citySecond
                zipSecond
                countrySecond
                notifAvailabilityMail
                notifAvailabilityPush
                notifReminderMail
                notifReminderPush
                notifBookingMail
                notifBookingPush
                notifEventMail
                notifEventPush
                notifNewPostPush
                notifTaskNote
                notifTaskNotePush
                dataSharingConsent
                childs {
                    id
                    firstname
                    birthdate
                    mon
                    tue
                    wed
                    thu
                    fri
                    sat
                    sun
                    daycares {
                        daycareId
                        request
                    }
                }
            }
            ... on Staff {
                userId
                email
                role
                firstname
                lastname
                phone
                address
                city
                zip
                country
                degree
                dataSharingConsent
            }
            ... on Trustee {
                userId
                email
                role
                firstname
                lastname
                phone
                address
                city
                zip
                country
            }
            __typename
        }
    }
`

export const UPDATE_ACCOUNT: DocumentNode = gql`
    mutation UpdateAccount(
        $firstname: String
        $lastname: String
        $phone: Phone
        $phoneSecond: Phone
        $address: String
        $city: String
        $zip: String
        $country: String
        $addressSecond: String
        $citySecond: String
        $zipSecond: String
        $diploma: Diplomas
        $countrySecond: String
        $notifAvailabilityMail: Boolean
        $notifAvailabilityPush: Boolean
        $notifReminderMail: Boolean
        $notifReminderPush: Boolean
        $notifBookingMail: Boolean
        $notifBookingPush: Boolean
        $notifEventMail: Boolean
        $notifEventPush: Boolean
        $notifNewPostPush: Boolean
        $notifTaskNote: Boolean
        $notifTaskNotePush: Boolean
        $language: String
    ) {
        updateAccount(
            user: {
                firstname: $firstname
                lastname: $lastname
                phone: $phone
                phoneSecond: $phoneSecond
                address: $address
                city: $city
                zip: $zip
                country: $country
                addressSecond: $addressSecond
                citySecond: $citySecond
                zipSecond: $zipSecond
                degree: $diploma
                countrySecond: $countrySecond
                notifAvailabilityMail: $notifAvailabilityMail
                notifAvailabilityPush: $notifAvailabilityPush
                notifReminderMail: $notifReminderMail
                notifReminderPush: $notifReminderPush
                notifBookingMail: $notifBookingMail
                notifBookingPush: $notifBookingPush
                notifEventMail: $notifEventMail
                notifEventPush: $notifEventPush
                notifNewPostPush: $notifNewPostPush
                notifTaskNote: $notifTaskNote
                notifTaskNotePush: $notifTaskNotePush
                language: $language
            }
        )
    }
`

export const SIGN_IN: DocumentNode = gql`
    mutation SignIn($email: Email!, $password: String!, $pushToken: String, $deviceType: String, $autoLink: String) {
        signIn(
            email: $email
            password: $password
            pushToken: $pushToken
            deviceType: $deviceType
            autoLink: $autoLink
        ) {
            token
            accountNotCompleted
            user {
                daycares {
                    id
                    active
                    staffAccess
                    type
                    name
                    manager
                    email
                    phone
                    address
                    city
                    zip
                    country
                    bookMin
                    bookWeeklyLimit
                    bookRange
                    autoLink
                    autoLinkEnable
                    internalAutoLink
                    internalAutoLinkEnable
                    externalAutoLink
                    externalAutoLinkEnable
                    trusteeWrite
                    merger
                    created
                    updated
                    validityEnd
                    timezone
                    activeAlert
                    alertRange
                    alertComment
                    mailSignature
                    staffCount
                    expirationDuration
                    newsAccess
                    limitByWeek
                    limitOfSlot
                    exceedLimit
                    suggestAccess
                    taskNoteAccess
                    mealAccess
                    annuaireId
                    colors {
                        daycareDark
                        daycareMain
                        daycareLight
                        daycareExtraLight
                        parentDark
                        parentMain
                        parentLight
                        parentExtraLight
                    }
                    logoBase64Data
                    accessibility {
                        id
                        type
                        start
                        end
                    }
                    staffLink {
                        notifReport
                        notifNewParent
                        notifPushNewParent
                        notifUpdateParent
                        notifPushUpdateParent
                        notifNewStaff
                        notifPushNewStaff
                        notifConfirmation
                        notifPushConfirmation
                        notifCancellation
                        notifPushCancellation
                        notifRequestSlot
                        notifPushRequestSlot
                        notifEventDays
                        notifPushEventDays
                        notifRegularSlot
                        notifPushRegularSlot
                        notifTaskNote
                        notifPushTaskNote
                        level
                        rw_params_daycare
                        rw_staffs
                        rw_staff_work
                        rw_families
                        rw_child
                        rw_occasional_slot
                        rw_request_slot
                        rw_regular_slot
                        rw_news
                        rw_event_days
                        rw_closing_days
                        w_add_posts
                        rw_suggestions
                        rw_task_note
                        rw_meal
                    }
                    opening {
                        monOpen
                        monClose
                        monBreakStart
                        monBreakEnd
                        tueOpen
                        tueClose
                        tueBreakStart
                        tueBreakEnd
                        wedOpen
                        wedClose
                        wedBreakStart
                        wedBreakEnd
                        thuOpen
                        thuClose
                        thuBreakStart
                        thuBreakEnd
                        friOpen
                        friClose
                        friBreakStart
                        friBreakEnd
                        satOpen
                        satClose
                        satBreakStart
                        satBreakEnd
                        sunOpen
                        sunClose
                        sunBreakStart
                        sunBreakEnd
                    }
                    groups {
                        id
                        name
                    }
                    sections {
                        id
                        max
                        name
                        sectionGroupId
                    }
                    sectionsGroups {
                        id
                        name
                        sections
                        rate
                    }
                    levels {
                        id
                        name
                        required
                    }
                    predefinedMessages {
                        type
                        message
                    }
                    releaseParameters {
                        releaseActivation
                        releaseWeekCountBefore
                        releaseDayCountBefore
                        releaseDay
                        releaseHour
                    }
                    haveDaycareGroup
                }
                currentDaycare {
                    id
                    active
                    staffAccess
                    type
                    name
                    manager
                    email
                    phone
                    address
                    city
                    zip
                    country
                    bookMin
                    bookWeeklyLimit
                    bookRange
                    autoLink
                    autoLinkEnable
                    internalAutoLink
                    internalAutoLinkEnable
                    externalAutoLink
                    externalAutoLinkEnable
                    trusteeWrite
                    merger
                    created
                    updated
                    validityEnd
                    timezone
                    activeAlert
                    alertRange
                    alertComment
                    mailSignature
                    staffCount
                    expirationDuration
                    newsAccess
                    limitByWeek
                    limitOfSlot
                    exceedLimit
                    suggestAccess
                    taskNoteAccess
                    mealAccess
                    annuaireId
                    colors {
                        daycareDark
                        daycareMain
                        daycareLight
                        daycareExtraLight
                        parentDark
                        parentMain
                        parentLight
                        parentExtraLight
                    }
                    logoBase64Data
                    accessibility {
                        id
                        type
                        start
                        end
                    }
                    staffLink {
                        notifReport
                        notifNewParent
                        notifPushNewParent
                        notifUpdateParent
                        notifPushUpdateParent
                        notifNewStaff
                        notifPushNewStaff
                        notifConfirmation
                        notifPushConfirmation
                        notifCancellation
                        notifPushCancellation
                        notifRequestSlot
                        notifPushRequestSlot
                        notifEventDays
                        notifPushEventDays
                        notifRegularSlot
                        notifPushRegularSlot
                        notifTaskNote
                        notifPushTaskNote
                        level
                        rw_params_daycare
                        rw_staffs
                        rw_staff_work
                        rw_families
                        rw_child
                        rw_occasional_slot
                        rw_request_slot
                        rw_regular_slot
                        rw_news
                        rw_event_days
                        rw_closing_days
                        w_add_posts
                        rw_suggestions
                        rw_task_note
                        rw_meal
                    }
                    opening {
                        monOpen
                        monClose
                        monBreakStart
                        monBreakEnd
                        tueOpen
                        tueClose
                        tueBreakStart
                        tueBreakEnd
                        wedOpen
                        wedClose
                        wedBreakStart
                        wedBreakEnd
                        thuOpen
                        thuClose
                        thuBreakStart
                        thuBreakEnd
                        friOpen
                        friClose
                        friBreakStart
                        friBreakEnd
                        satOpen
                        satClose
                        satBreakStart
                        satBreakEnd
                        sunOpen
                        sunClose
                        sunBreakStart
                        sunBreakEnd
                    }
                    groups {
                        id
                        name
                    }
                    sections {
                        id
                        max
                        name
                        sectionGroupId
                    }
                    sectionsGroups {
                        id
                        name
                        sections
                        rate
                    }
                    levels {
                        id
                        name
                        required
                    }
                    predefinedMessages {
                        type
                        message
                    }
                    releaseParameters {
                        releaseActivation
                        releaseWeekCountBefore
                        releaseDayCountBefore
                        releaseDay
                        releaseHour
                    }
                    haveDaycareGroup
                }
                role
                email
                language
            }
        }
    }
`

export const SIGN_UP: DocumentNode = gql`
    mutation SignUp(
        $email: Email!
        $password: String!
        $pptosAcceptation: Boolean!
        $pushToken: String
        $deviceType: String
        $role: Role!
        $isNanny: Boolean!
        $autoLink: String
    ) {
        signUp(
            email: $email
            password: $password
            pushToken: $pushToken
            pptosAcceptation: $pptosAcceptation
            deviceType: $deviceType
            role: $role
            isNanny: $isNanny
            autoLink: $autoLink
        ) {
            token
            user {
                daycares {
                    id
                    active
                    staffAccess
                    type
                    name
                    manager
                    email
                    phone
                    address
                    city
                    zip
                    country
                    bookMin
                    bookWeeklyLimit
                    bookRange
                    autoLink
                    autoLinkEnable
                    internalAutoLink
                    internalAutoLinkEnable
                    externalAutoLink
                    externalAutoLinkEnable
                    trusteeWrite
                    merger
                    created
                    updated
                    validityEnd
                    timezone
                    activeAlert
                    alertRange
                    alertComment
                    mailSignature
                    staffCount
                    expirationDuration
                    newsAccess
                    limitByWeek
                    limitOfSlot
                    exceedLimit
                    suggestAccess
                    taskNoteAccess
                    mealAccess
                    annuaireId
                    colors {
                        daycareDark
                        daycareMain
                        daycareLight
                        daycareExtraLight
                        parentDark
                        parentMain
                        parentLight
                        parentExtraLight
                    }
                    logoBase64Data
                    accessibility {
                        id
                        type
                        start
                        end
                    }
                    staffLink {
                        notifReport
                        notifNewParent
                        notifPushNewParent
                        notifUpdateParent
                        notifPushUpdateParent
                        notifNewStaff
                        notifPushNewStaff
                        notifConfirmation
                        notifPushConfirmation
                        notifCancellation
                        notifPushCancellation
                        notifRequestSlot
                        notifPushRequestSlot
                        notifEventDays
                        notifPushEventDays
                        notifRegularSlot
                        notifPushRegularSlot
                        notifTaskNote
                        notifPushTaskNote
                        level
                        rw_params_daycare
                        rw_staffs
                        rw_staff_work
                        rw_families
                        rw_child
                        rw_occasional_slot
                        rw_request_slot
                        rw_regular_slot
                        rw_news
                        rw_event_days
                        rw_closing_days
                        w_add_posts
                        rw_suggestions
                        rw_task_note
                        rw_meal
                    }
                    opening {
                        monOpen
                        monClose
                        monBreakStart
                        monBreakEnd
                        tueOpen
                        tueClose
                        tueBreakStart
                        tueBreakEnd
                        wedOpen
                        wedClose
                        wedBreakStart
                        wedBreakEnd
                        thuOpen
                        thuClose
                        thuBreakStart
                        thuBreakEnd
                        friOpen
                        friClose
                        friBreakStart
                        friBreakEnd
                        satOpen
                        satClose
                        satBreakStart
                        satBreakEnd
                        sunOpen
                        sunClose
                        sunBreakStart
                        sunBreakEnd
                    }
                    groups {
                        id
                        name
                    }
                    sections {
                        id
                        max
                        name
                        sectionGroupId
                    }
                    sectionsGroups {
                        id
                        name
                        sections
                        rate
                    }
                    levels {
                        id
                        name
                        required
                    }
                    predefinedMessages {
                        type
                        message
                    }
                    releaseParameters {
                        releaseActivation
                        releaseWeekCountBefore
                        releaseDayCountBefore
                        releaseDay
                        releaseHour
                    }
                    haveDaycareGroup
                }
                currentDaycare {
                    id
                    active
                    staffAccess
                    type
                    name
                    manager
                    email
                    phone
                    address
                    city
                    zip
                    country
                    bookMin
                    bookWeeklyLimit
                    bookRange
                    autoLink
                    autoLinkEnable
                    internalAutoLink
                    internalAutoLinkEnable
                    externalAutoLink
                    externalAutoLinkEnable
                    trusteeWrite
                    merger
                    created
                    updated
                    validityEnd
                    timezone
                    activeAlert
                    alertRange
                    alertComment
                    mailSignature
                    staffCount
                    expirationDuration
                    newsAccess
                    limitByWeek
                    limitOfSlot
                    exceedLimit
                    suggestAccess
                    taskNoteAccess
                    mealAccess
                    annuaireId
                    colors {
                        daycareDark
                        daycareMain
                        daycareLight
                        daycareExtraLight
                        parentDark
                        parentMain
                        parentLight
                        parentExtraLight
                    }
                    logoBase64Data
                    accessibility {
                        id
                        type
                        start
                        end
                    }
                    staffLink {
                        notifReport
                        notifNewParent
                        notifPushNewParent
                        notifUpdateParent
                        notifPushUpdateParent
                        notifNewStaff
                        notifPushNewStaff
                        notifConfirmation
                        notifPushConfirmation
                        notifCancellation
                        notifPushCancellation
                        notifRequestSlot
                        notifPushRequestSlot
                        notifEventDays
                        notifPushEventDays
                        notifRegularSlot
                        notifPushRegularSlot
                        notifTaskNote
                        notifPushTaskNote
                        level
                        rw_params_daycare
                        rw_staffs
                        rw_staff_work
                        rw_families
                        rw_child
                        rw_occasional_slot
                        rw_request_slot
                        rw_regular_slot
                        rw_news
                        rw_event_days
                        rw_closing_days
                        w_add_posts
                        rw_suggestions
                        rw_task_note
                        rw_meal
                    }
                    opening {
                        monOpen
                        monClose
                        monBreakStart
                        monBreakEnd
                        tueOpen
                        tueClose
                        tueBreakStart
                        tueBreakEnd
                        wedOpen
                        wedClose
                        wedBreakStart
                        wedBreakEnd
                        thuOpen
                        thuClose
                        thuBreakStart
                        thuBreakEnd
                        friOpen
                        friClose
                        friBreakStart
                        friBreakEnd
                        satOpen
                        satClose
                        satBreakStart
                        satBreakEnd
                        sunOpen
                        sunClose
                        sunBreakStart
                        sunBreakEnd
                    }
                    groups {
                        id
                        name
                    }
                    sections {
                        id
                        max
                        name
                        sectionGroupId
                    }
                    sectionsGroups {
                        id
                        name
                        sections
                        rate
                    }
                    levels {
                        id
                        name
                        required
                    }
                    predefinedMessages {
                        type
                        message
                    }
                    releaseParameters {
                        releaseActivation
                        releaseWeekCountBefore
                        releaseDayCountBefore
                        releaseDay
                        releaseHour
                    }
                    haveDaycareGroup
                }
                role
                email
                language
            }
        }
    }
`

export const GET_VERIFY_EMAIL: DocumentNode = gql`
    query getVerifyEmail($email: Email!) {
        getVerifyEmail(email: $email)
    }
`

export const UPDATE_ACCOUNT_LANGUAGE: DocumentNode = gql`
    mutation UpdateAccountLanguage($language: String!) {
        updateAccountLanguage(language: $language)
    }
`

export const SET_DATA_SHARING_CONSENT: DocumentNode = gql`
    mutation setDataSharingConsent($consent: Boolean!) {
        setDataSharingConsent(consent: $consent)
    }
`

export const SEND_HELP_SUPPORT: DocumentNode = gql`
    mutation SendHelpSupport($email: String!, $deviceInfo: DeviceInfo) {
        sendHelpSupport(email: $email, deviceInfo: $deviceInfo)
    }
`

export const GET_USER_FROM_TOKEN: DocumentNode = gql`
    query getContextResponse($daycareId: Int, $pushToken: String, $deviceType: String) {
        getContextResponse(daycareId: $daycareId, pushToken: $pushToken, deviceType: $deviceType) {
            token
            user {
                daycares {
                    id
                    active
                    staffAccess
                    type
                    name
                    manager
                    email
                    phone
                    address
                    city
                    zip
                    country
                    bookMin
                    bookWeeklyLimit
                    bookRange
                    autoLink
                    autoLinkEnable
                    internalAutoLink
                    internalAutoLinkEnable
                    externalAutoLink
                    externalAutoLinkEnable
                    trusteeWrite
                    merger
                    created
                    updated
                    validityEnd
                    timezone
                    activeAlert
                    alertRange
                    alertComment
                    mailSignature
                    staffCount
                    expirationDuration
                    newsAccess
                    limitByWeek
                    limitOfSlot
                    exceedLimit
                    suggestAccess
                    taskNoteAccess
                    mealAccess
                    annuaireId
                    colors {
                        daycareDark
                        daycareMain
                        daycareLight
                        daycareExtraLight
                        parentDark
                        parentMain
                        parentLight
                        parentExtraLight
                    }
                    accessibility {
                        id
                        type
                        start
                        end
                    }
                    logoBase64Data
                    staffLink {
                        notifReport
                        notifNewParent
                        notifPushNewParent
                        notifUpdateParent
                        notifPushUpdateParent
                        notifNewStaff
                        notifPushNewStaff
                        notifConfirmation
                        notifPushConfirmation
                        notifCancellation
                        notifPushCancellation
                        notifRequestSlot
                        notifPushRequestSlot
                        notifEventDays
                        notifPushEventDays
                        notifRegularSlot
                        notifPushRegularSlot
                        notifTaskNote
                        notifPushTaskNote
                        level
                        rw_params_daycare
                        rw_staffs
                        rw_staff_work
                        rw_families
                        rw_child
                        rw_occasional_slot
                        rw_request_slot
                        rw_regular_slot
                        rw_news
                        rw_event_days
                        rw_closing_days
                        w_add_posts
                        rw_suggestions
                        rw_task_note
                        rw_meal
                    }
                    opening {
                        monOpen
                        monClose
                        monBreakStart
                        monBreakEnd
                        tueOpen
                        tueClose
                        tueBreakStart
                        tueBreakEnd
                        wedOpen
                        wedClose
                        wedBreakStart
                        wedBreakEnd
                        thuOpen
                        thuClose
                        thuBreakStart
                        thuBreakEnd
                        friOpen
                        friClose
                        friBreakStart
                        friBreakEnd
                        satOpen
                        satClose
                        satBreakStart
                        satBreakEnd
                        sunOpen
                        sunClose
                        sunBreakStart
                        sunBreakEnd
                    }
                    groups {
                        id
                        name
                    }
                    sections {
                        id
                        max
                        name
                        sectionGroupId
                    }
                    sectionsGroups {
                        id
                        name
                        sections
                        rate
                    }
                    levels {
                        id
                        name
                        required
                    }
                    predefinedMessages {
                        type
                        message
                    }
                    releaseParameters {
                        releaseActivation
                        releaseWeekCountBefore
                        releaseDayCountBefore
                        releaseDay
                        releaseHour
                    }
                    haveDaycareGroup
                }
                currentDaycare {
                    id
                    active
                    staffAccess
                    type
                    name
                    manager
                    email
                    phone
                    address
                    city
                    zip
                    country
                    bookMin
                    bookWeeklyLimit
                    bookRange
                    autoLink
                    autoLinkEnable
                    internalAutoLink
                    internalAutoLinkEnable
                    externalAutoLink
                    externalAutoLinkEnable
                    trusteeWrite
                    merger
                    created
                    updated
                    validityEnd
                    timezone
                    activeAlert
                    alertRange
                    alertComment
                    mailSignature
                    staffCount
                    expirationDuration
                    newsAccess
                    limitByWeek
                    limitOfSlot
                    exceedLimit
                    suggestAccess
                    taskNoteAccess
                    mealAccess
                    annuaireId
                    colors {
                        daycareDark
                        daycareMain
                        daycareLight
                        daycareExtraLight
                        parentDark
                        parentMain
                        parentLight
                        parentExtraLight
                    }
                    logoBase64Data
                    accessibility {
                        id
                        type
                        start
                        end
                    }
                    staffLink {
                        notifReport
                        notifNewParent
                        notifPushNewParent
                        notifUpdateParent
                        notifPushUpdateParent
                        notifNewStaff
                        notifPushNewStaff
                        notifConfirmation
                        notifPushConfirmation
                        notifCancellation
                        notifPushCancellation
                        notifRequestSlot
                        notifPushRequestSlot
                        notifEventDays
                        notifPushEventDays
                        notifRegularSlot
                        notifPushRegularSlot
                        notifTaskNote
                        notifPushTaskNote
                        level
                        rw_params_daycare
                        rw_staffs
                        rw_staff_work
                        rw_families
                        rw_child
                        rw_occasional_slot
                        rw_request_slot
                        rw_regular_slot
                        rw_news
                        rw_event_days
                        rw_closing_days
                        w_add_posts
                        rw_suggestions
                        rw_task_note
                        rw_meal
                    }
                    opening {
                        monOpen
                        monClose
                        monBreakStart
                        monBreakEnd
                        tueOpen
                        tueClose
                        tueBreakStart
                        tueBreakEnd
                        wedOpen
                        wedClose
                        wedBreakStart
                        wedBreakEnd
                        thuOpen
                        thuClose
                        thuBreakStart
                        thuBreakEnd
                        friOpen
                        friClose
                        friBreakStart
                        friBreakEnd
                        satOpen
                        satClose
                        satBreakStart
                        satBreakEnd
                        sunOpen
                        sunClose
                        sunBreakStart
                        sunBreakEnd
                    }
                    groups {
                        id
                        name
                    }
                    sections {
                        id
                        max
                        name
                        sectionGroupId
                    }
                    sectionsGroups {
                        id
                        name
                        sections
                        rate
                    }
                    levels {
                        id
                        name
                        required
                    }
                    predefinedMessages {
                        type
                        message
                    }
                    releaseParameters {
                        releaseActivation
                        releaseWeekCountBefore
                        releaseDayCountBefore
                        releaseDay
                        releaseHour
                    }
                    haveDaycareGroup
                }
                role
                email
                language
            }
        }
    }
`

export const RECAPTCHA: DocumentNode = gql`
    query captcha($response: String!) {
        recaptcha(response: $response)
    }
`

export const GET_ACCOUNT_CITIES_MATCH: DocumentNode = gql`
    query getAccountCitiesMatch($city: String!, $country: String!) {
        getAccountCitiesMatch(city: $city, country: $country)
    }
`

export const SEARCH_DAYCARE_COUNT: DocumentNode = gql`
    query searchDaycareCount {
        searchDaycareCount
    }
`

export const CONTACT_DAYCARE_FOR_DELETE_ACCOUNT: DocumentNode = gql`
    mutation contactDaycareForDeleteAccount($userId: Int!) {
        contactDaycareForDeleteAccount(userId: $userId)
    }
`

export const GET_VERIFY_AUTO_LINK: DocumentNode = gql`
    query getVerifyAutoLink($autoLink: String!) {
        getVerifyAutoLink(autoLink: $autoLink) {
            colors {
                daycareDark
                daycareMain
                daycareLight
                daycareExtraLight
                parentDark
                parentMain
                parentLight
                parentExtraLight
            }
            logoBase64Data
        }
    }
`
